import React, {Component} from 'react';
import IntakeFormRadTextEnum from "./enum/IntakeFormRadTextEnum";
import FormField from "../../../components/form/FormField";
import {DateInput, RadioInput, SelectInput, TextInput} from "../../../components";
import DateUtil from "../../../utils/DateUtil";
import {Dropdown} from "primereact/dropdown";
import IntakeFormGenderEnum from "../intakeform/enum/IntakeFormGenderEnum";
import IntakeFormYesNoEnum from "../intakeform/enum/IntakeFormYesNoEnum";
import IntakeFormAllergySection from "./IntakeFormAllergySection";

class IntakeFormRadPersonalInformation extends Component {
    render() {
        const {
            selectedLanguage, readOnly, enumLabel, nationalityLabel, onChange, pushFormFieldRef,
            firstName, middleName, lastName, dob, age, gender, idNo, nationality, nationalities,
            maritalStatus, maritalStatuses, religion, religions, language, languages,
            haveAllergies, allergy, allergyTypes, allergenTypes, allergySeverities, allergenReactionTypes,
            onAllergyChanged
        } = this.props

        return (
            <div className="container dim14-form-row-align">
                <h3 className="text-center mb-3">
                    <b>{IntakeFormRadTextEnum.Personal_Information[selectedLanguage]}</b>
                </h3>
                
                {/* Name Fields */}
                <div className="row">
                    <div className="col-4 d-flex">
                        <p className={"dim14-form-label mr-3 mb-0"}>
                            {IntakeFormRadTextEnum.First_Name[selectedLanguage]}:
                        </p>
                        <FormField
                            ref={(formField) => pushFormFieldRef(formField)}
                            required
                            requiredMessage={IntakeFormRadTextEnum.Required_Field[selectedLanguage]}
                            validateOn={readOnly ? true : firstName}
                        >
                            <TextInput
                                value={firstName}
                                alphabeticOnly
                                disabled={readOnly}
                                onChange={(value) => onChange("firstName", value)}
                            />
                        </FormField>
                    </div>
                    <div className="col-4 d-flex">
                        <p className={"dim14-form-label mr-3 mb-0"}>
                            {IntakeFormRadTextEnum.Middle_Name[selectedLanguage]}:
                        </p>
                        <TextInput
                            value={middleName}
                            alphabeticOnly
                            disabled={readOnly}
                            onChange={(value) => onChange("middleName", value)}
                        />
                    </div>
                    <div className="col-4 d-flex justify-content-end">
                        <p className={"dim14-form-label mr-3 mb-0"}>
                            {IntakeFormRadTextEnum.Last_Name[selectedLanguage]}:
                        </p>
                        <FormField
                            ref={(formField) => pushFormFieldRef(formField)}
                            required
                            requiredMessage={IntakeFormRadTextEnum.Required_Field[selectedLanguage]}
                            validateOn={readOnly ? true : lastName}
                        >
                            <TextInput
                                value={lastName}
                                alphabeticOnly
                                disabled={readOnly}
                                onChange={(value) => onChange("lastName", value)}
                            />
                        </FormField>
                    </div>
                </div>

                {/* Date of Birth, Age, Gender */}
                <div className="row mt-2">
                    <div className="col-4 dim14-form-label">
                        {IntakeFormRadTextEnum.Date_of_Birth[selectedLanguage]}:
                    </div>
                    <div className="col-8">
                        <div className="d-flex">
                            <div className="col-3">
                                <FormField
                                    ref={(formField) => pushFormFieldRef(formField)}
                                    required
                                    requiredMessage={IntakeFormRadTextEnum.Required_Field[selectedLanguage]}
                                    validateOn={readOnly ? true : dob}
                                >
                                    <DateInput
                                        className={
                                            readOnly
                                                ? "dim14-datepicker DateInputDisabledBackground"
                                                : "dim14-datepicker"
                                        }
                                        disableFuture="true"
                                        disabled={readOnly}
                                        value={dob ? dob : new Date()}
                                        onChange={(val) => {
                                            onChange("dob", val);
                                            onChange("age", DateUtil.getAgeWithMonths(val));
                                        }}
                                    />
                                </FormField>
                            </div>

                            <div className="col-4 d-flex">
                                <b className="mx-2">
                                    {IntakeFormRadTextEnum.Age[selectedLanguage]}
                                </b>
                                <div>
                                    {dob
                                        ? DateUtil.getAgeWithMonths(dob)
                                        : "Select birthday."}
                                </div>
                            </div>

                            <div className="col-5 d-flex justify-content-end">
                                <div className="dim14-form-label mx-2">
                                    {IntakeFormRadTextEnum.Gender[selectedLanguage]}:
                                </div>

                                <FormField
                                    ref={(formField) => pushFormFieldRef(formField)}
                                    required
                                    requiredMessage={IntakeFormRadTextEnum.Required_Field[selectedLanguage]}
                                    validateOn={readOnly ? true : gender}
                                >
                                    <Dropdown
                                        className={`GenderDropdown ${
                                            readOnly
                                                ? "DropdownDisabledBackground"
                                                : "DropdownBorderColor"
                                        }`}
                                        value={gender}
                                        disabled={readOnly}
                                        options={IntakeFormGenderEnum.toArray().map(v => {
                                            return {value: v.key, label: v[enumLabel]}
                                        })}
                                        displayProperty="label"
                                        valueProperty="value"
                                        onChange={(event) => onChange("gender", event.value)}
                                    />
                                </FormField>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ID Number */}
                <div className="row">
                    <div className="col-4 dim14-form-label">
                        {IntakeFormRadTextEnum.ID_No[selectedLanguage]}:
                    </div>
                    <div className="col-8">
                        <FormField
                            ref={(formField) => pushFormFieldRef(formField)}
                            required
                            requiredMessage={IntakeFormRadTextEnum.Required_Field[selectedLanguage]}
                            validateOn={readOnly ? true : idNo}
                        >
                            <TextInput
                                className="w-100"
                                value={idNo}
                                disabled={readOnly}
                                onChange={(value) => onChange("idNo", value)}
                            />
                        </FormField>
                    </div>
                </div>

                {/* Nationality */}
                <div className="row">
                    <div className="col-4 dim14-form-label">
                        {IntakeFormRadTextEnum.Nationality[selectedLanguage]}:
                    </div>
                    <div className="col-8">
                        <FormField
                            ref={(formField) => pushFormFieldRef(formField)}
                            required
                            requiredMessage={IntakeFormRadTextEnum.Required_Field[selectedLanguage]}
                            validateOn={readOnly ? true : nationality}
                        >
                            <Dropdown
                                className={`DropdownBorderColor ${
                                    readOnly ? "DropdownDisabledBackground" : ""
                                }`}
                                value={nationality}
                                disabled={readOnly}
                                dataKey={"id"}
                                options={nationalities}
                                optionLabel={"name"}
                                filter
                                filterLocale={"en-US"}
                                filterBy={"name"}
                                onChange={(event) => onChange("nationality", event.value)}
                            />
                        </FormField>
                    </div>
                </div>

                {/* Marital Status */}
                <div className="row">
                    <div className="col-4 dim14-form-label">
                        {IntakeFormRadTextEnum.Marital_Status[selectedLanguage]}:
                    </div>
                    <div className="col-8">
                        <FormField
                            ref={(formField) => pushFormFieldRef(formField)}
                            required
                            requiredMessage={IntakeFormRadTextEnum.Required_Field[selectedLanguage]}
                            validateOn={readOnly ? true : maritalStatus}
                        >
                            <SelectInput
                                value={maritalStatus}
                                searchEnabled={false}
                                options={maritalStatuses}
                                displayProperty={"name"}
                                disabled={readOnly}
                                onChange={(val) => onChange('maritalStatus', val)}
                            />
                        </FormField>
                    </div>
                </div>

                {/* Religion */}
                <div className="row">
                    <div className="col-4 dim14-form-label">
                        {IntakeFormRadTextEnum.Religion[selectedLanguage]}:
                    </div>
                    <div className="col-8">
                        <FormField
                            ref={(formField) => pushFormFieldRef(formField)}
                            required
                            requiredMessage={IntakeFormRadTextEnum.Required_Field[selectedLanguage]}
                            validateOn={readOnly ? true : religion}
                        >
                            <SelectInput
                                value={religion}
                                searchEnabled={false}
                                options={religions}
                                displayProperty={"name"}
                                disabled={readOnly}
                                onChange={(val) => onChange('religion', val)}
                            />
                        </FormField>
                    </div>
                </div>

                {/* Language */}
                <div className="row">
                    <div className="col-4 dim14-form-label">
                        {IntakeFormRadTextEnum.Language[selectedLanguage]}:
                    </div>
                    <div className="col-8">
                        <FormField
                            ref={(formField) => pushFormFieldRef(formField)}
                            required
                            requiredMessage={IntakeFormRadTextEnum.Required_Field[selectedLanguage]}
                            validateOn={readOnly ? true : language}
                        >
                            <SelectInput
                                value={language}
                                searchEnabled={false}
                                options={languages}
                                displayProperty={"name"}
                                disabled={readOnly}
                                onChange={(val) => onChange('language', val)}
                            />
                        </FormField>
                    </div>
                </div>

                {/* Allergies or Sensitivities */}
                <div className="row">
                    <div className="col-4 dim14-form-label">
                        {IntakeFormRadTextEnum.Allergies_Or_Sensitivities[selectedLanguage]}
                    </div>
                    <div className="col-8">
                        <FormField
                            ref={(formField) => pushFormFieldRef(formField)}
                            required
                            requiredMessage={IntakeFormRadTextEnum.Required_Field[selectedLanguage]}
                            validateOn={readOnly ? true : haveAllergies}
                        >
                            <RadioInput
                                id="allergiesRadioInput"
                                value={haveAllergies}
                                disabled={readOnly}
                                options={IntakeFormYesNoEnum.toArray()}
                                displayProperty={enumLabel}
                                valueProperty={"key"}
                                onChange={(value) => onChange("haveAllergies", value)}
                            />
                        </FormField>
                    </div>
                </div>

                {/* Allergies Details (if Yes selected) */}
                {haveAllergies === "Yes" ? (
                    <div className="container">
                        <IntakeFormAllergySection
                            allergy={allergy}
                            readOnly={readOnly}
                            selectedLanguage={selectedLanguage}
                            allergyTypes={allergyTypes}
                            allergenTypes={allergenTypes}
                            allergySeverities={allergySeverities}
                            allergenReactionTypes={allergenReactionTypes}
                            onAllergyChanged={onAllergyChanged}
                        />
                        <FormField
                            ref={(formField) => pushFormFieldRef(formField)}
                            required
                            requiredMessage={IntakeFormRadTextEnum.Required_Field[selectedLanguage]}
                            customValidator={(val) => val === true || (allergy?.items?.length > 0)}
                            customValidatorMessage={IntakeFormRadTextEnum.Required_Field[selectedLanguage]}
                            validateOn={readOnly ? true : allergy?.items?.length > 0}>
                            <div/>
                        </FormField>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default IntakeFormRadPersonalInformation;